module.exports = __webpack_public_path__ + "img/set3.f8180f59.svg";